export default function(){
    (function($) {
        $(document).on('modal_opened', function(id, context){
            let $modal = $("[data-modal-id='" + context + "']");
            if ($modal.hasClass("dialog")) {
                $('body').addClass("has-dialog");
            }
        })
    })(jQuery);
}